import type { Address } from '@lmc/ts-common'
import { Button, FormCard, Trash, theme } from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { type ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { DeleteButtonText } from '../../../../styledComponents'
import { PostcodeAutofill } from './PostocdeAutofill'

type AddressFormProps = {
  title: string
  onAddressDelete?: () => void
  children: ReactNode
  mandatoryFields?: ReactNode
  fieldName: (string | number)[]
  onAutofill: (values: Partial<Address>) => void
  initialIsAddingAddressManually: boolean
}

export const AddressForm = ({
  title,
  onAddressDelete,
  children,
  fieldName,
  onAutofill,
  mandatoryFields,
  initialIsAddingAddressManually
}: AddressFormProps) => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)
  const [isAddingAddressManually, setIsAddingAddressManually] = useState(
    initialIsAddingAddressManually
  )

  return (
    <FormCard
      level={2}
      title={title}
      rightChildren={
        onAddressDelete && (
          <Button
            variant="text"
            type="button"
            icon={<Trash color={theme.color.neutral.color4} />}
            onClick={onAddressDelete}
          >
            <DeleteButtonText>
              {t(supConstants.DELETE_ADDRESS)}
            </DeleteButtonText>
          </Button>
        )
      }
    >
      {mandatoryFields}
      <ShouldShow $shouldShow={isAddingAddressManually}>{children}</ShouldShow>
      <PostcodeAutofill
        onAutofill={onAutofill}
        fieldName={fieldName}
        onManuallyChoose={() => setIsAddingAddressManually(true)}
        isAddingAddressManually={isAddingAddressManually}
      />
    </FormCard>
  )
}

// we use this because we need the <Form> tags into the dom for result
const ShouldShow = styled.div<{ $shouldShow: boolean }>`
  display: ${(props) => (props.$shouldShow ? 'contents' : 'none')};
`
